/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Narrows the Cut selected tile by where the selection came from. Only rows that actually carry survey data are attributed, so manualSeed is not offered here — an unpicked placeholder has no selection to attribute, and those composites are reachable via rowStatus=needSelection instead. A composite holding cuts from more than one source matches every source it contains.
 */
export enum SurveyReplacementCompositeDataCutSelectionSourceFilter {
    REUSED_FROM_PRIOR = 'reusedFromPrior',
    DEFAULTED_FROM_POLICY = 'defaultedFromPolicy',
    MANUALLY_PICKED = 'manuallyPicked',
}
